import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
  apiStatus,
  BatchService,
  appStatus,
  formatDate,
  getCategoryByValue,
  getCategoryRoute,
  getStatus,
  StatusService,
  SignalRService,
  Project,
  Projects,
} from '@lead-hunter/data-access';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subscription } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import { WarningProcessComponent } from '../../../../components/warning-process';
import { WarningRemoveComponent } from '../../../../components/warning-remove';

@Component({
  selector: 'lead-analyzes',
  templateUrl: './analyzes.component.html',
  styleUrls: ['./analyzes.component.scss'],
})
export class AnalyzesComponent implements OnInit, OnDestroy, AfterViewInit {

  public formatDate = formatDate;
  public getCategoryRoute = getCategoryRoute;
  public getCategoryByValue = getCategoryByValue;
  public apiStatus = apiStatus;
  public status = appStatus;
  public getStatus = getStatus;

  public currentProjects: Project[];
  public originalCurrentProject: Project[];

  public totalDocs: number;

  public totalPages: number;
  public currentPage: number;
  public perPage: number;
  public isUpdateFiles: boolean;

  public files$: Observable<Projects>;

  public pooling: Subscription;

  public searchMode: boolean;

  private lastSearchValue: string;

  private subscriptions: Subscription[] = [];

  constructor(
    private batchService: BatchService,
    public router: Router,
    public spinner: NgxSpinnerService,
    private dialog: MatDialog,
    public statusService: StatusService,
    private signalRService: SignalRService,
    private cdr: ChangeDetectorRef
  ) { }

  ngAfterViewInit(): void {
    this.subscriptions.push(
      this.signalRService.onHubNotification()
        .subscribe(
          {
            next: (value): void => this.updateProjects(value),
          }
        )
    )
  }

  updateProjects(value: any) {
    if (this.currentPage === 1) {
      const project = JSON.parse(value.res);
      const currentProject = this.currentProjects.find(currentProject => currentProject.id === project.id);

      if (currentProject) {
        this.currentProjects.map(async (data) => {

          if (data.id === project.id) {
            data.status = project.status;
            if(project.status === 'DONE'){
              const countsResponse = (await this.batchService.mount(data.id).toPromise()).countsResponse;
              data.countsResponse = countsResponse;
              this.cdr.detectChanges();
            }  
          }
        })

      } else {
        this.currentProjects.unshift(project);
        this.currentProjects.pop();
      }
      this.cdr.detectChanges();
    }
  }

  ngOnInit(): void {
    this.isUpdateFiles = false;
    this.currentPage = 1;
    this.perPage = 10;
    this.spinner.show();
    this.getFiles();
  }

  updateSearch(element) {
    this.totalPages = element.totalPages;
    this.totalDocs = element.totalDocs;
    this.currentProjects = element.docs;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(
      (subscription) => subscription.unsubscribe && subscription.unsubscribe()
    );
  }

  async getFiles(next?: number, search?: string) {
    if (next) this.currentPage = next;
    if (search) this.lastSearchValue = search;
    if (this.isUpdateFiles) {
      if (this.searchMode) {
        this.batchService
          .get(this.currentPage, this.perPage, this.lastSearchValue)
          .toPromise()
          .then((res) => {
            this.updateSearch(res);
          });
        return;
      }
      this.batchService
        .get(this.currentPage, this.perPage)
        .toPromise()
        .then((res) => {
          this.updateSearch(res);
          this.originalCurrentProject = [...this.currentProjects];
        });

      return;
    }

    this.files$ = this.batchService.get(this.currentPage, this.perPage).pipe(
      tap((res) => {
        this.updateSearch(res);
        this.originalCurrentProject = [...this.currentProjects];
        this.isUpdateFiles = true;
        this.spinner.hide();
      })
    );
    this.files$.toPromise().catch((e) => {
      console.error(e);
      this.router.navigateByUrl('/analysis');
    });
  }

  removeFile(id) {
    const dialogRef = this.dialog.open(WarningRemoveComponent, {
      backdropClass: 'custom-backdrop',
      panelClass: 'custom-panel',
    });
    dialogRef.componentInstance.id = id;
    dialogRef.beforeClosed().subscribe(() => {
      this.getFiles().then(() => {
        this.spinner.hide();
      });
    });
  }

  refresh(): void {
    window.location.reload();
  }

  openProcessModal() {
    this.dialog.open(WarningProcessComponent, {
      backdropClass: 'custom-backdrop',
      panelClass: 'custom-panel',
    });
  }
}
